import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useSubscriptionItem} from '../hooks/useSubscriptionItem';
import {SubscriptionItem} from '../types';
import {useParams} from 'react-router-dom';

export const AddFormDrawer = (props: DrawerProps) => {

    const {id: subscriptionId} = useParams();

    if (typeof subscriptionId === 'undefined') {
        throw new Error('subscriptionId is required parameter');
    }

    const {createRecord} = useSubscriptionItem(subscriptionId);

    return (
        <FormDrawer
            record={{
                id: '',
                price: '',
                subscription: '',
            } as SubscriptionItem}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
